export const CUSTOM = "CUSTOM";
export const DEFAULT = "DEFAULT";


// WEBPACK FOOTER //
// ./src/components/common/enums/memberIdentifierType.js